import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cx from "classnames";
import "./HamburgerMenu.scss";
const HamburgerMenu = forwardRef(({ isOpen, onClick, className }, ref) => {
    return (_jsx("div", { ref: ref, onClick: onClick, className: cx("burger-wrapper", { "burger-wrapper-expanded": isOpen }, className), children: _jsx("div", { className: "hamburger" }) }));
});
export default HamburgerMenu;
